var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-3 col-md" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "searchKeyword" } }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.i18n("ORGANIZATION.EMPLOYEE_SEARCH")) +
                        " "
                    ),
                  ]),
                  _c("el-input", {
                    attrs: {
                      id: "searchKeyword",
                      clearable: "",
                      placeholder: "請輸入帳號或姓名或Email或工號",
                    },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.searchPerson({
                          page: 1,
                          per_page: 10,
                        })
                      },
                    },
                    model: {
                      value: _vm.searchKeyword,
                      callback: function ($$v) {
                        _vm.searchKeyword =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "searchKeyword",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.searchPerson({
                        page: 1,
                        per_page: 10,
                      })
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.SEARCH")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#personModal",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.personModal(true)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.ADD_EMPLOYEE")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-info",
                  staticStyle: { "margin-top": "30px" },
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#uploadModal",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.IMPORT_DATA")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "content-wrap" }, [
        _c(
          "div",
          { staticClass: "tree-wrap", staticStyle: { cursor: "default" } },
          [
            _c(
              "VueTreeList",
              {
                attrs: { model: _vm.tree, "default-expanded": true },
                on: { click: _vm.onClick, drop: _vm.drop },
                scopedSlots: _vm._u([
                  {
                    key: "leafNameDisplay",
                    fn: function (slotProps) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "node",
                            class: {
                              "active-node":
                                slotProps.model.id === _vm.selectedNode,
                            },
                          },
                          [
                            _c("div", { staticClass: "node-content" }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    "vertical-align": "top",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "department-name" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            slotProps.model.DepartmentName
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "department-code" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            slotProps.model.DepartmentCode
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "add-folder",
                                  staticStyle: { "margin-left": "5px" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addDepartment(slotProps.model)
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      name: "plus-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                              slotProps.model.pid !== 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "edit-folder",
                                      staticStyle: { "margin-left": "5px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editDepartment(
                                            slotProps.model
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("eva-icon", {
                                        attrs: {
                                          width: "16",
                                          height: "16",
                                          name: "edit-outline",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              slotProps.model.pid !== 0 &&
                              slotProps.model.id === _vm.selectedNode
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "delete-folder",
                                      staticStyle: { "margin-left": "5px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDel(slotProps.model)
                                        },
                                      },
                                    },
                                    [
                                      _c("eva-icon", {
                                        attrs: {
                                          width: "16",
                                          height: "16",
                                          name: "trash-2-outline",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "icon",
                    staticStyle: { display: "none" },
                    attrs: { slot: "treeNodeIcon" },
                    slot: "treeNodeIcon",
                  },
                  [_vm._v("🌲")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "icon",
                    staticStyle: { display: "none" },
                    attrs: { slot: "addTreeNodeIcon" },
                    slot: "addTreeNodeIcon",
                  },
                  [_vm._v(" 📂 ")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "icon",
                    staticStyle: { display: "none" },
                    attrs: { slot: "addLeafNodeIcon" },
                    slot: "addLeafNodeIcon",
                  },
                  [_vm._v(" ＋ ")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "icon",
                    staticStyle: { display: "none" },
                    attrs: { slot: "editNodeIcon" },
                    slot: "editNodeIcon",
                  },
                  [_vm._v("📃")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "icon",
                    staticStyle: { display: "none" },
                    attrs: { slot: "delNodeIcon" },
                    slot: "delNodeIcon",
                  },
                  [_vm._v("✂️")]
                ),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "department-wrap" }, [
          _c(
            "div",
            { staticClass: "yahome-table-wrap" },
            [
              _c("div", {
                staticStyle: { "text-align": "right", "margin-bottom": "10px" },
              }),
              _c(
                "VueBootstrap4Table",
                {
                  attrs: {
                    rows: _vm.rows,
                    columns: _vm.columns,
                    config: _vm.config,
                    "total-rows": _vm.totalData,
                  },
                  on: { "on-change-query": _vm.onChangeQuery },
                  scopedSlots: _vm._u([
                    {
                      key: "account",
                      fn: function (props) {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                "data-target": "#personModal",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.personModal(false, props.row)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(props.row.Account) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "slot_supervisor",
                      fn: function (props) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#13ce66",
                              "inactive-color": "#808080",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.setSupervisor(props.row)
                              },
                            },
                            model: {
                              value: props.row.IsSupervisor,
                              callback: function ($$v) {
                                _vm.$set(props.row, "IsSupervisor", $$v)
                              },
                              expression: "props.row.IsSupervisor",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "slot_IsEnabled",
                      fn: function (props) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#13ce66",
                              "inactive-color": "#808080",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.setIsEnabled(props.row)
                              },
                            },
                            model: {
                              value: props.row.IsEnabled,
                              callback: function ($$v) {
                                _vm.$set(props.row, "IsEnabled", $$v)
                              },
                              expression: "props.row.IsEnabled",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "delete",
                      fn: function (props) {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger btn-delete btn-sm",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                "data-target": "#delPersonModal",
                              },
                              on: {
                                "!click": function ($event) {
                                  return _vm.delModal(props.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.i18n("BUTTON.DELETE")) + " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "empty-results" }, [
                    _vm._v(_vm._s(_vm.i18n("PUBLIC.NO_RESULT"))),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "departmentModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  ref: "department",
                  staticClass: "modal-content",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit, reset }) {
                        return [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return handleSubmit(_vm.saveDepartment)
                                },
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "modal-header" }, [
                                _vm.isAddDepartment
                                  ? _c("span", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "badge badge-primary",
                                          staticStyle: { "font-size": "15px" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.ParentDepartmentName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.i18n(
                                              "ORGANIZATION.ADD_DEPARTMENT"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.i18n(
                                            "ORGANIZATION.EDIT_DEPARTMENT"
                                          )
                                        )
                                      ),
                                    ]),
                              ]),
                              _c("div", { staticClass: "modal-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "DepartmentName",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.i18n(
                                                            "ORGANIZATION.DEPARTMENT_NAME"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.department
                                                          .DepartmentName,
                                                      expression:
                                                        "department.DepartmentName",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    id: "DepartmentName",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.department
                                                        .DepartmentName,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.department,
                                                        "DepartmentName",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "DepartmentCode",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.i18n(
                                                            "ORGANIZATION.DEPARTMENT_CODE"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("(不可重複)")]
                                                    ),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.department
                                                          .DepartmentCode,
                                                      expression:
                                                        "department.DepartmentCode",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    id: "DepartmentCode",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.department
                                                        .DepartmentCode,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.department,
                                                        "DepartmentCode",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "reset",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("BUTTON.CANCEL")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "submit" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("BUTTON.SAVE")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "delDepartmentModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.i18n("ORGANIZATION.DELETE_DEPARTMENT"))),
                ]),
              ]),
              _vm.canDelete
                ? _c("div", { staticClass: "modal-body" }, [
                    _vm._v(" 確認刪除"),
                    _c(
                      "span",
                      {
                        staticStyle: { "font-weight": "bolder", color: "red" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.department.DepartmentName) + " "
                        ),
                      ]
                    ),
                    _vm._v(" ? "),
                  ])
                : _c("div", { staticClass: "modal-body" }, [
                    _vm._v(" 若欲刪除 "),
                    _c(
                      "span",
                      {
                        staticStyle: { "font-weight": "bolder", color: "red" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.department.DepartmentName) + " "
                        ),
                      ]
                    ),
                    _vm._v("，需先刪除底下的 "),
                    _c(
                      "span",
                      {
                        staticStyle: { "font-weight": "bolder", color: "red" },
                      },
                      [_vm._v("部門及人員")]
                    ),
                    _vm._v("。 "),
                  ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: {
                      click: function ($event) {
                        _vm.canDelete = false
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.CANCEL")) + " ")]
                ),
                _vm.canDelete
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { type: "button" },
                        on: { click: _vm.delDepartment },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.DELETE")) + " ")]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "personModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered" },
            [
              _c("ValidationObserver", {
                ref: "person",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return handleSubmit(_vm.savePerson)
                              },
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-header" }, [
                              _vm.isPersonAdd
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n("ORGANIZATION.ADD_EMPLOYEE")
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.i18n("ORGANIZATION.EDIT_EMPLOYEE")
                                      )
                                    ),
                                  ]),
                            ]),
                            _c("div", { staticClass: "modal-body" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                { attrs: { for: "Account" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "ORGANIZATION.ACCOUNT"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                attrs: {
                                                  id: "Account",
                                                  clearable: "",
                                                  maxlength: "50",
                                                  disabled: !_vm.isPersonAdd,
                                                },
                                                model: {
                                                  value: _vm.person.Account,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.person,
                                                      "Account",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression: "person.Account",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                { attrs: { for: "UserName" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "ORGANIZATION.USERNAME"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                attrs: {
                                                  id: "UserName",
                                                  clearable: "",
                                                  maxlength: "50",
                                                },
                                                model: {
                                                  value: _vm.person.UserName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.person,
                                                      "UserName",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression: "person.UserName",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  attrs: { for: "EmployeeNo" },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(" 工號 "),
                                                ]
                                              ),
                                              _c("el-input", {
                                                attrs: {
                                                  id: "EmployeeNo",
                                                  clearable: "",
                                                  maxlength: "20",
                                                },
                                                model: {
                                                  value: _vm.person.EmployeeNo,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.person,
                                                      "EmployeeNo",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "person.EmployeeNo",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: _vm.i18n("ORGANIZATION.EMAIL"),
                                      rules: "required|email",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                { attrs: { for: "Email" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "ORGANIZATION.EMAIL"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                attrs: {
                                                  id: "Email",
                                                  clearable: "",
                                                  maxlength: "50",
                                                },
                                                model: {
                                                  value: _vm.person.Email,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.person,
                                                      "Email",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression: "person.Email",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: _vm.i18n("ORGANIZATION.PHONE"),
                                      rules: "required|numeric",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  attrs: { for: "PhoneNumber" },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "ORGANIZATION.PHONE"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                attrs: {
                                                  id: "PhoneNumber",
                                                  clearable: "",
                                                  maxlength: "20",
                                                },
                                                model: {
                                                  value: _vm.person.PhoneNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.person,
                                                      "PhoneNumber",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "person.PhoneNumber",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(errors[0]) + " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                { attrs: { for: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "ORGANIZATION.PRIMARY_DEPARTMENT"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("treeselect", {
                                                attrs: {
                                                  options: _vm.departmentList,
                                                  searchable: true,
                                                  "show-count": true,
                                                  "default-expand-level": 1,
                                                  placeholder: "請選擇",
                                                },
                                                model: {
                                                  value:
                                                    _vm.mainDepartment
                                                      .DepartmentGuid,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.mainDepartment,
                                                      "DepartmentGuid",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "mainDepartment.DepartmentGuid",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c("span", { staticClass: "mark" }, [
                                      _vm._v("*"),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n("ORGANIZATION.IS_SUPERVISOR")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "w-100",
                                      model: {
                                        value: _vm.mainDepartment.IsSupervisor,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.mainDepartment,
                                            "IsSupervisor",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mainDepartment.IsSupervisor",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "是", value: true },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "否", value: false },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("hr"),
                                  _vm._l(
                                    _vm.othersDepartment,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticStyle: {
                                            "margin-bottom": "20px",
                                            display: "flex",
                                            "justify-content": "space-between",
                                            "font-size": "0.9em",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { flex: "1" } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n(
                                                      "ORGANIZATION.ADJUNCT_DEPARTMENT"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "rgb(236 241 255)",
                                                    "border-radius": "5px",
                                                    padding: "5px 10px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.DepartmentName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n("Basic.Supervisor")
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "rgb(236 241 255)",
                                                    "border-radius": "5px",
                                                    padding: "5px 10px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.IsSupervisor
                                                          ? "是"
                                                          : "否"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-danger btn-sm",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delItem(index)
                                                },
                                              },
                                            },
                                            [
                                              _c("eva-icon", {
                                                attrs: {
                                                  fill: "#FFF",
                                                  name: "trash-2-outline",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _vm.addOthersDepartment
                                        ? _c("AddDepartment", {
                                            on: {
                                              addDoubleAs: _vm.saveData,
                                              addCancel: function ($event) {
                                                _vm.addOthersDepartment = false
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      !_vm.addOthersDepartment
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-sm",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.addOthersDepartment = true
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-plus",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n(
                                                      "ORGANIZATION.ADJUNCT_DEPARTMENT"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v(
                                      _vm._s(_vm.i18n("ORGANIZATION.ROLE"))
                                    ),
                                  ]),
                                  _c("treeselect", {
                                    attrs: {
                                      multiple: true,
                                      options: _vm.roleOptions,
                                      placeholder: "請選擇",
                                      valueFormat: "object",
                                    },
                                    model: {
                                      value: _vm.personRoles,
                                      callback: function ($$v) {
                                        _vm.personRoles = $$v
                                      },
                                      expression: "personRoles",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "modal-footer" }, [
                              !_vm.isPersonAdd
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-warning",
                                      attrs: { type: "button" },
                                      on: { click: _vm.changePassword },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.i18n(
                                              "ORGANIZATION.CHANGE_PASSWORD"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    type: "button",
                                    "data-dismiss": "modal",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n("BUTTON.CANCEL")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: { type: "submit" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.i18n("BUTTON.SAVE")) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "delPersonModal",
            tabindex: "-1",
            "aria-labelledby": "delPersonModal",
            "aria-hidden": "true",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.i18n("ORGANIZATION.DELETE_EMPLOYEE"))),
                ]),
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _vm._v(" 確認刪除 "),
                _c(
                  "span",
                  { staticStyle: { "font-weight": "bolder", color: "red" } },
                  [_vm._v(" " + _vm._s(_vm.person.Name) + " ")]
                ),
                _vm._v(" ? "),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.CANCEL")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.delPerson },
                  },
                  [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.DELETE")) + " ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "uploadModal", tabindex: "-1" },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("span", [_vm._v(_vm._s(_vm.i18n("BUTTON.IMPORT_DATA")))]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c("p", { staticClass: "form-group" }, [
                      _c(
                        "u",
                        {
                          staticStyle: {
                            color: "midnightblue",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.downloadTemplate.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" 點擊下載範例檔 ")]
                      ),
                    ]),
                    _vm._m(0),
                    _c(
                      "div",
                      { staticClass: "from-group" },
                      [
                        _vm._m(1),
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            attrs: {
                              action: "",
                              accept: ".xls,.xlsx",
                              "auto-upload": false,
                              "show-file-list": false,
                              "on-change": _vm.uploadFile,
                              limit: 1,
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "small", type: "primary" } },
                              [_vm._v("點擊上傳")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "form-group" }, [
      _c("span", { staticClass: "mark" }, [
        _vm._v("* 檔案限制：[檔名].xlsx、[檔名].xls"),
      ]),
      _c("br"),
      _c("span", { staticClass: "mark" }, [_vm._v("* 大小限制：10MB 以下")]),
      _c("br"),
      _c("span", { staticClass: "mark" }, [
        _vm._v("* 上傳前請確認是否符合格式"),
      ]),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _c("span", { staticClass: "mark" }, [_vm._v("*")]),
      _vm._v("檔案"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }